/* Parsley Date Validator
===================================================================================================================== */

import Moment from 'moment-mini';
import Parsley from 'parsleyjs';

// Define Date Validator:
const DateValidator = () => {
  Parsley.addValidator('date', {
    validateString: function(value, requirement) {
      return Moment(value, requirement, true).isValid();
    }
  });
};

export default DateValidator;

